<template>
  <svg viewBox="0 0 512 350" v-on="$listeners">
    <path
      d="M85 64v235h214v64H0v-64h43V64q0-18 12.5-30.5T85 21h384v43H85zm406 43q8 0 14.5 6t6.5 15v213q0 9-6.5 15.5T491 363H363q-9 0-15.5-6.5T341 341V128q0-9 6.5-15t15.5-6h128zm-22 192V149h-85v150h85z"
      fill="currentColor"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'sonico',
}
</script>